import React, { useEffect, useContext } from "react";
import { ContextEngine } from "./engine/ContextEngine";
import { Top, Left, Right, Bottom, Central } from "./components";
import Splitter from "../components/Splitter/Splitter";
import StatusBar from "./components/StatusBar";
import ModalRenderer from "./modals/ModalRenderer";
import "./TractumUI1.css";

// --- This component handles the UI and the Key Listeners ---
const TractumLayout = () => {
  const { context, updateContext } = useContext(ContextEngine);

  useEffect(() => {
    const handleKeyDown = (e) => {
      // Restore from Maximized on Escape
      if (e.key === "Escape" && context.panelVisibility?.bottomMaximized) {
        updateContext("panelVisibility.bottomMaximized", false);
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [context.panelVisibility?.bottomMaximized, updateContext]);

  return (
    <div className="tractum-ui" style={{ height: "100vh", display: "flex", flexDirection: "column", overflow: "hidden" }}>
      <Top />
      
      <div style={{ flex: 1, display: 'flex', overflow: 'hidden' }}>
        <Splitter
          left={<Left />}
          center={<Central />}
          right={<Right />}
          // Only show bottom if it's visible in state
          bottom={context.panelVisibility?.bottom ? <Bottom /> : null}
        />
      </div>

      <StatusBar />
      <ModalRenderer />
      
    </div>
  );
};

// --- The Main Export stays clean ---
const TractumUI = () => (
    <TractumLayout />
);

export default TractumUI;
